import * as React from "react";
import * as Yup from 'yup';
import { Box, Container, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import { makeStyles } from "@mui/styles";
import { muiThemeDesign } from '../../mui-theme-design';
import { MuiThemeProvider } from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {checkAuthentication} from '../../utils';


export default function EditAppRoleDialog({ handleEditCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    checkAuthentication();
  //  console.log({ Data: data });
    const initialValues = {
        Name: data.AppRoleName,
        IsActive: data.IsActive ? true : false,
        ViewFinancials: data.ViewFinancials ? true : false,
        GlobalAccess: data.GlobalAccess ? true : false,
        CanBeAssignedTo: data.CanBeAssignedTo ? true : false,
        CreateEvent: data.CreateEvent ? true : false,
        ViewAppRoles: data.ViewAppRoles ? true : false,
        CreateAppRoles: data.CreateAppRoles ? true : false,
        ViewUser: data.ViewUser ? true : false,
        CreateUser: data.CreateUser ? true : false,
        ViewUserRoles: data.ViewUserRoles ? true : false,
        EditUserRoles: data.EditUserRoles ? true : false,
        CreateUserRoles: data.CreateUserRoles ? true : false,
        ViewUserProperties: data.ViewUserProperties ? true : false,
        CreateUserProperties: data.CreateUserProperties ? true : false,
        ViewEntry: data.ViewEntry ? true : false,
        CreateEntry: data.CreateEntry ? true : false,
        ViewSOW: data.ViewSOW ? true : false,
        CreateSOW: data.CreateSOW ? true : false,
        ViewCostCenter: data.ViewCostCenter ? true : false,
        CreateCostCenter: data.CreateCostCenter ? true : false,
        ViewPO: data.ViewPO ? true : false,
        CreatePO: data.CreatePO ? true : false,
        ViewLab: data.ViewLab ? true : false,
        CreateLab: data.CreateLab ? true : false,
        ViewProjects: data.ViewProjects ? true : false,
        CreateProjects: data.CreateProjects ? true : false,
        ViewTasks: data.ViewTasks ? true : false,
        CreateTasks: data.CreateTasks ? true : false,
        ViewTaskGroup: data.ViewTaskGroup ? true : false,
        CreateTaskGroup: data.CreateTaskGroup ? true : false,
        ViewTaskVariables: data.ViewTaskVariables ? true : false,
        CreateTaskVariables: data.CreateTaskVariables ? true : false,
        CreateInvoice: data.CreateInvoice ? true : false,
        CreateExpense: data.CreateExpense ? true : false,
        ViewPosition: data.ViewPosition ? true : false,
        CreatePosition: data.CreatePosition ? true : false,
        CreateRate: data.CreateRate ? true : false,
        CreateClientSite: data.CreateClientSite ? true : false
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a name for the position')
            .required('Position name is required'),
        IsActive: Yup
            .boolean(),
        ViewFinancials: Yup
            .boolean(),
        GlobalAccess: Yup
            .boolean(),
        CanBeAssignedTo: Yup
            .boolean(),
        CreateEvent: Yup
            .boolean(),
        ViewAppRoles: Yup
            .boolean(),
        CreateAppRoles: Yup
            .boolean(),
        ViewUser: Yup
            .boolean(),
        CreateUser: Yup
            .boolean(),
        ViewUserRoles: Yup
            .boolean(),
        EditUserRoles: Yup
            .boolean(),
        CreateUserRoles: Yup
            .boolean(),
        ViewUserProperties: Yup
            .boolean(),
        CreateUserProperties: Yup
            .boolean(),
        ViewEntry: Yup
            .boolean(),
        CreateEntry: Yup
            .boolean(),
        ViewSOW: Yup
            .boolean(),
        CreateSOW: Yup
            .boolean(),
        ViewCostCenter: Yup
            .boolean(),
        CreateCostCenter: Yup
            .boolean(),
        ViewPO: Yup
            .boolean(),
        CreatePO: Yup
            .boolean(),
        ViewLab: Yup
            .boolean(),
        CreateLab: Yup
            .boolean(),
        ViewProjects: Yup
            .boolean(),
        CreateProjects: Yup
            .boolean(),
        ViewTasks: Yup
            .boolean(),
        CreateTasks: Yup
            .boolean(),
        ViewTaskGroup: Yup
            .boolean(),
        CreateTaskGroup: Yup
            .boolean(),
        ViewTaskVariables: Yup
            .boolean(),
        CreateTaskVariables: Yup
            .boolean(),
        CreateInvoice: Yup
            .boolean(),
        CreateExpense: Yup
            .boolean(),
        ViewPosition: Yup
            .boolean(),
        CreatePosition: Yup
            .boolean(),
        CreateRate: Yup
            .boolean(),
        CreateClientSite: Yup
        	.boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            ID: data.ID,
            AppRoleName: values.Name,
            IsActive: values.IsActive ? 1 : 0,
            ViewFinancials: values.ViewFinancials ? 1 : 0,
            GlobalAccess: values.GlobalAccess ? 1 : 0,
            CanBeAssignedTo: values.CanBeAssignedTo ? 1 : 0,
            CreateEvent: values.CreateEvent ? 1 : 0,
            ViewAppRoles: values.ViewAppRoles ? 1 : 0,
            CreateAppRoles: values.CreateAppRoles ? 1 : 0,
            ViewUser: values.ViewUser ? 1 : 0,
            CreateUser: values.CreateUser ? 1 : 0,
            ViewUserRoles: values.ViewUserRoles ? 1 : 0,
            EditUserRoles: values.EditUserRoles ? 1 : 0,
            CreateUserRoles: values.CreateUserRoles ? 1 : 0,
            ViewUserProperties: values.ViewUserProperties ? 1 : 0,
            CreateUserProperties: values.CreateUserProperties ? 1 : 0,
            ViewEntry: values.ViewEntry ? 1 : 0,
            CreateEntry: values.CreateEntry ? 1 : 0,
            ViewSOW: values.ViewSOW ? 1 : 0,
            CreateSOW: values.CreateSOW ? 1 : 0,
            ViewCostCenter: values.ViewCostCenter ? 1 : 0,
            CreateCostCenter: values.CreateCostCenter ? 1 : 0,
            ViewPO: values.ViewPO ? 1 : 0,
            CreatePO: values.CreatePO ? 1 : 0,
            ViewLab: values.ViewLab ? 1 : 0,
            CreateLab: values.CreateLab ? 1 : 0,
            ViewProjects: values.ViewProjects ? 1 : 0,
            CreateProjects: values.CreateProjects ? 1 : 0,
            ViewTasks: values.ViewTasks ? 1 : 0,
            CreateTasks: values.CreateTasks ? 1 : 0,
            ViewTaskGroup: values.ViewTaskGroup ? 1 : 0,
            CreateTaskGroup: values.CreateTaskGroup ? 1 : 0,
            ViewTaskVariables: values.ViewTaskVariables ? 1 : 0,
            CreateTaskVariables: values.CreateTaskVariables ? 1 : 0,
            CreateInvoice: values.CreateInvoice ? 1 : 0,
            CreateExpense: values.CreateExpense ? 1 : 0,
            ViewPosition: values.ViewPosition ? 1 : 0,
            CreatePosition: values.CreatePosition ? 1 : 0,
            CreateRate: values.CreateRate ? 1 : 0,
            CreateClientSite: values.CreateClientSite ? 1 : 0,
        };

        handleEditCallback(msg);
        handleClose();
        setRefresh(false);
    })

    const handleClickOpen = () => {        
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <div><MuiThemeProvider theme={muiThemeDesign}>
            <Tooltip title="Edit" placement="top-end">
                <IconButton variant="contained" onClick={handleClickOpen}>
                    <BorderColorRoundedIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            App Role
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>App Role Info:</DialogTitle>
                                <div>
                                    <Typography variant="h4" sx={{ m: 5 }} color="common.black">
                                        Role Name/Title:
                                    </Typography>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="Name"
                                            id="outlined-name"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                                <div>

                                    <Typography variant="h4" sx={{ m: 5 }} color="common.black">
                                        Permissions:
                                    </Typography>

                             
                                            <Grid container rowSpacing={1} columnSpacing={1}> 
                                                     <Grid item xs={2}> 
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewFinancials"
                                            label="ViewFinancials"
                                            control={<Checkbox checked={props.values.ViewFinancials} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="GlobalAccess"
                                            label="GlobalAccess"
                                            control={<Checkbox checked={props.values.GlobalAccess} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CanBeAssignedTo"
                                            label="CanBeAssignedTo"
                                            control={<Checkbox checked={props.values.CanBeAssignedTo} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateEvent"
                                            label="CreateEvent"
                                            control={<Checkbox checked={props.values.CreateEvent} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewAppRoles"
                                            label="ViewAppRoles"
                                            control={<Checkbox checked={props.values.ViewAppRoles} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>
                                             
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateAppRoles"
                                            label="CreateAppRoles"
                                            control={<Checkbox checked={props.values.CreateAppRoles} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewUser"
                                            label="ViewUser"
                                            control={<Checkbox checked={props.values.ViewUser} onChange={props.handleChange} />}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={2}>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateUser"
                                            label="CreateUser"
                                            control={<Checkbox checked={props.values.CreateUser} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewUserRoles"
                                            label="ViewUserRoles"
                                            control={<Checkbox checked={props.values.ViewUserRoles} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="EditUserRoles"
                                            label="EditUserRoles"
                                            control={<Checkbox checked={props.values.EditUserRoles} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>

                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateUserRoles"
                                            label="CreateUserRoles"
                                            control={<Checkbox checked={props.values.CreateUserRoles} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewUserProperties"
                                            label="ViewUserProperties"
                                            control={<Checkbox checked={props.values.ViewUserProperties} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateUserProperties"
                                            label="CreateUserProperties"
                                            control={<Checkbox checked={props.values.CreateUserProperties} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewEntry"
                                            label="ViewEntry"
                                            control={<Checkbox checked={props.values.ViewEntry} onChange={props.handleChange} />}
                                        />
                                                </FormControl>

                                            </Grid>
                                            <Grid item xs={2}> 
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateEntry"
                                            label="CreateEntry"
                                            control={<Checkbox checked={props.values.CreateEntry} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>

                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewSOW"
                                            label="ViewSOW"
                                            control={<Checkbox checked={props.values.ViewSOW} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateSOW"
                                            label="CreateSOW"
                                            control={<Checkbox checked={props.values.CreateSOW} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewCostCenter"
                                            label="ViewCostCenter"
                                            control={<Checkbox checked={props.values.ViewCostCenter} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateCostCenter"
                                            label="CreateCostCenter"
                                            control={<Checkbox checked={props.values.CreateCostCenter} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewPO"
                                            label="ViewPO"
                                            control={<Checkbox checked={props.values.ViewPO} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>

                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreatePO"
                                            label="CreatePO"
                                            control={<Checkbox checked={props.values.CreatePO} onChange={props.handleChange} />}
                                        />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={2}> 
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewLab"
                                            label="ViewLab"
                                            control={<Checkbox checked={props.values.ViewLab} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateLab"
                                            label="CreateLab"
                                            control={<Checkbox checked={props.values.CreateLab} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewProjects"
                                            label="ViewProjects"
                                            control={<Checkbox checked={props.values.ViewProjects} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateProjects"
                                            label="CreateProjects"
                                            control={<Checkbox checked={props.values.CreateProjects} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>

                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewTasks"
                                            label="ViewTasks"
                                            control={<Checkbox checked={props.values.ViewTasks} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateTasks"
                                            label="CreateTasks"
                                            control={<Checkbox checked={props.values.CreateTasks} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewTaskGroup"
                                            label="ViewTaskGroup"
                                            control={<Checkbox checked={props.values.ViewTaskGroup} onChange={props.handleChange} />}
                                        />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={2}> 
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateTaskGroup"
                                            label="CreateTaskGroup"
                                            control={<Checkbox checked={props.values.CreateTaskGroup} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewTaskVariables"
                                            label="ViewTaskVariables"
                                            control={<Checkbox checked={props.values.ViewTaskVariables} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateTaskVariables"
                                            label="CreateTaskVariables"
                                            control={<Checkbox checked={props.values.CreateTaskVariables} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>

                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateInvoice"
                                            label="CreateInvoice"
                                            control={<Checkbox checked={props.values.CreateInvoice} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateExpense"
                                            label="CreateExpense"
                                            control={<Checkbox checked={props.values.CreateExpense} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="ViewPosition"
                                            label="ViewPosition"
                                            control={<Checkbox checked={props.values.ViewPosition} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreatePosition"
                                            label="CreatePosition"
                                            control={<Checkbox checked={props.values.CreatePosition} onChange={props.handleChange} />}
                                        />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={2}> 
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateRate"
                                            label="CreateRate"
                                            control={<Checkbox checked={props.values.CreateRate} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="CreateClientSite"
                                            label="CreateClientSite"
                                            control={<Checkbox checked={props.values.CreateClientSite} onChange={props.handleChange} />}
                                        />
                                                    </FormControl>
                                                </Grid>
                                        </Grid>
                                                
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                </Dialog>
             </MuiThemeProvider>
        </div>
    );
}